import mapboxgl from "mapbox-gl";
import { get } from "svelte/store";

import AlertsStore from "../Alerts/Store";
import GeoHelper from "../Helpers/GeoHelper";
import MapStore from "./Store";

import bbox from "@turf/bbox";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { polygon } from "@turf/helpers";

import Feature from "../Branding/Feature";
import User from "../Branding/User";

import ShippingLanesStore from "../ShippingLanes/Store";

import PopupStore from "./Popup/PopupStore";
import "./ROIPopup.scss";

const ROIPopupManager = {

};

ROIPopupManager.init = (map, rois) => {
	const markers = [];

	for (let i = 0; i < rois.features.length; i++) {
		const roi = rois.features[i];

		const coords = GeoHelper.calcTopCenter(roi);
		const el = document.createElement("div");
		el.className = "roi-info-marker";

		const marker = new mapboxgl.Marker(el, { anchor: "center" });
		marker.setLngLat(coords);

		// Get all of the vessels
		// Read all of the alerts in ROI
		// Summarise
		const popupHtml = `<div class="roi-popup"'>
							<h3>${roi.properties.name}</h3>
							<p><span id="count-vessels">0</span> <span id="count-vessels-word">Vessels</span></p>
							<div style='width: 100%;' id="count-alert-types"></div>
							<p><a id="select-all-area-${i}">Select All</a>  |  <a id="focus-area-${i}">Focus Area</a></p>
							<p id="shipping-lanes-container-${i}" style="display:none;"><a id="shipping-lanes-${i}">Shipping Lanes</a></p>
						</div>`;
		const popup = new mapboxgl.Popup({ offset: 20, className: "roi-popup", color: "white" });
		popup.setHTML(popupHtml);
		marker.setPopup(popup);
		marker.addTo(map);

		markers.push(marker);

		((i) => {
			const getVesselsInROI = (roi, params = { asCounts: false }) => {
				const geom = roi.geometry.coordinates[0];
				console.log("geom", geom);
				const poly1 = polygon([geom]);

				const vesselsAll = get(AlertsStore.vesselGroup.vessels);
				const vesselsIn = [];
				const alertTypeBreakdown = {};

				for (let j = 0; j < vesselsAll.length; j++) {
					const vessel = vesselsAll[j];

					const intersection = booleanPointInPolygon(vessel.coordinates, poly1);
					if (intersection) {
						vesselsIn.push(vessel);
						if (params.asCounts) {
							vessel.alertTypes.forEach(alertType => {
								const existingCount = alertTypeBreakdown[alertType];
								if (existingCount) alertTypeBreakdown[alertType]++;
								else alertTypeBreakdown[alertType] = 1;
							});
						}
					}
				}
				console.log("vesselsIn", vesselsIn);

				if (params.asCounts) return { total: vesselsIn.length, alertTypeBreakdown: alertTypeBreakdown };
				return vesselsIn;
			};
			popup.on("open", () => {
				const selectAllButton = document.querySelector("#select-all-area-" + i);
				const focusAreaButton = document.querySelector("#focus-area-" + i);
				const shippingLanesContainer = document.querySelector("#shipping-lanes-container-" + i);
				const shippingLanesButton = document.querySelector("#shipping-lanes-" + i);

				setTimeout(() => {
					const vesselsWord = document.querySelector("#count-vessels-word");
					const vesselsCount = document.querySelector("#count-vessels");
					const typesCount = document.querySelector("#count-alert-types");
					const counts = getVesselsInROI(rois.features[i], { asCounts: true });
					vesselsCount.innerHTML = "" + counts.total;
					vesselsWord.innerHTML = (counts.total === 1) ? "Vessel" : "Vessels";
					typesCount.innerHTML = PopupStore.helpers.generateKeyValueList(
						counts.alertTypeBreakdown,
						{
							asTable: true,
							isAlertTypes: true
						}
					);
					shippingLanesContainer.style.display = (User.hasFeature(Feature.SHIPPING_LANES.VIEW)) ? "block" : "none";
				}, 1);

				const z = () => {
					MapStore.helpers.zoomToCoordinateListBounds(rois.features[i].geometry.coordinates);
					popup.remove();
				};
				focusAreaButton.removeEventListener("click", z);
				focusAreaButton.addEventListener("click", z);

				const selectAllEvent = () => {
					const vesselsInArea = getVesselsInROI(rois.features[i]);
					AlertsStore.vesselGroup.deselectAll();
					for (let j = 0; j < vesselsInArea.length; j++) {
						const mmsi = vesselsInArea[j].mmsi;
						const vs = AlertsStore.vesselGroup.find({ mmsi: mmsi });
						if (vs) {
							vs.selected = true;
						}
					}
					AlertsStore.vesselGroup.update();

					popup.remove();
				};
				selectAllButton.removeEventListener("click", selectAllEvent);
				selectAllButton.addEventListener("click", selectAllEvent);

				const showShippingLane = () => {
					const thisBounds = bbox(roi);
					console.log("thisBounds", thisBounds);

					ShippingLanesStore.startForBounds(thisBounds);

					ShippingLanesStore.visible.set(true);
					popup.remove();
				};
				shippingLanesButton.removeEventListener("click", showShippingLane);
				shippingLanesButton.addEventListener("click", showShippingLane);
			});
		})(i);
	}

	MapStore.rois.infoMarkers.set(markers);
};
export default ROIPopupManager;
